import { ApiRequest, ApiResponse, HttpMethod } from '@axl/accel-framework/api';

export class RefreshTokenRequest extends ApiRequest {
    public method = HttpMethod.PUT;
    public url: string = '/authorization/refresh';
    public body: any = {
        token: this.refreshToken
    };
    public authorized = false;

    constructor(public refreshToken: string) {
        super();
    }
}

export class RefreshTokenResponse extends ApiResponse {
    constructor(response: any) {
        super(response);
    }
}